import { toast } from "react-toastify";

import {
  fetchApprovedRequestPOStart,
  fetchApprovedRequestPOSuccess,
  fetchApprovedRequestPOFailure,
} from "./reducer";

import { ADMIN_APPROVE_PO_REQUEST } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const approvedRequestPO =
  (jsonObj, orderId, itemId, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchApprovedRequestPOStart());
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        ADMIN_APPROVE_PO_REQUEST(orderId, itemId),
        "PUT",
        jsonObj,
      );

      if (response?.error) {
        dispatch(fetchApprovedRequestPOFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchApprovedRequestPOSuccess(response));
        dispatch(setSuccessMessage(true));
        if (jsonObj?.status === "approved") {
          toast.success("Purchase order request approved successfully");
        }
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      dispatch(fetchApprovedRequestPOFailure("Something went wrong"));
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
